import { render } from "./ChargebeeUpsellConfigPV3.vue?vue&type=template&id=be81eeb8&scoped=true"
import script from "./ChargebeeUpsellConfigPV3.vue?vue&type=script&lang=js"
export * from "./ChargebeeUpsellConfigPV3.vue?vue&type=script&lang=js"

import "./ChargebeeUpsellConfigPV3.vue?vue&type=style&index=0&id=be81eeb8&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be81eeb8"]])

export default __exports__